import type { LaunchActivitySnapshot } from "../lib/launch-activity";
import "./LaunchActivity.css";

export function LaunchActivity({ activity, onMinimize, onRestore, onDismiss }: {
  activity: LaunchActivitySnapshot | null;
  onMinimize(): void;
  onRestore(): void;
  onDismiss(): void;
}) {
  if (!activity) return null;
  if (!activity.visible) return <button className="launch-activity-restore" type="button" onClick={onRestore}>
    Show launch status
  </button>;

  const running = activity.status === "running";
  const canDismiss = !running && activity.status !== "submitted";
  const heading = activity.status === "submitted" ? "Transaction submitted" : activity.status === "confirmed" ? "Transaction confirmed" :
    activity.status === "completed" ? "Action complete" : activity.status === "needs_check" ? "Status needs checking" :
      activity.status === "failed" ? "Action did not complete" : activity.status === "blocked" ? "Action blocked" : "Launch activity";

  return <aside className="launch-activity" role="dialog" aria-label="Launch activity" aria-live="polite" aria-atomic="false">
    <div className="launch-activity-header">
      <div className="launch-activity-title-row">
        {running && <span className="launch-activity-spinner" role="status" aria-label="In progress" />}
        <h2>{heading}</h2>
      </div>
      {canDismiss
        ? <button type="button" className="launch-activity-minimize" onClick={onDismiss}>Close status</button>
        : <button type="button" className="launch-activity-minimize" onClick={onMinimize}>Minimize status</button>}
    </div>
    <ol className="launch-activity-timeline">
      {activity.steps.map((step) => <li key={step.id} data-step-status={step.status} aria-current={step.status === "current" ? "step" : undefined}>
        <span className="launch-activity-step-marker" aria-hidden="true" />
        <span>{step.label}</span>
      </li>)}
    </ol>
    {activity.message && <p className="launch-activity-message" role={activity.status === "failed" || activity.status === "needs_check" || activity.status === "blocked" ? "status" : undefined}>
      {activity.message}
    </p>}
  </aside>;
}
